import request from '@/utils/request'

 // 查询供应商产能列表
  export function apiMdmOrgSrAssignmentsLinelist (query) {
    return request({
      url: `/mdm/mdmOrgSrAssignments/lineList`,
      method: 'get',
      params: query
    })
  }
 // 批量修改物料来源
 export function apiMdmOrgSrAssignments (query) {
    return request({
      url: `/mdm/mdmOrgSrAssignments`,
      method: 'post',
      data: query
    })
  }
   // 查询物料来源供应商下拉列表
 export function apiMdmOrgSupplierList (query) {
    return request({
      url: `/mdm/mdmOrgSrAssignments/mdmOrgSupplierList`,
      method: 'get',
      params: query
    })
  }
 // 删除物料来源
 export function apiDelItemApportion (ids) {
  return request({
    url: `/mdm/mdmOrgSrAssignments/${ids}`,
    method: 'delete'
  })
}
